
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const NameAnalysisDeleteOverTimePage = lazy(() => import('./NameAnalysisDeleteOverTimePage'));
const path = 'reports/subword-frequency/delete-over-time';
const NameAnalysisDeleteOverTimeRoute: FuseRouteItemType = {
	path: path,
	element: <NameAnalysisDeleteOverTimePage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Name Analysis For Delete Over Time',
					helpName: 'Name Analysis For Delete Over Time',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default NameAnalysisDeleteOverTimeRoute;
